import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import { deleteApi } from '../../apiUtils';
import { TerminalMappingsDataGrid } from '../../components/datagrid/TerminalMappingsDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useTranslation } from '../../contexts/translation';
import { confirmDialogActions, useConfirmDialog } from '../../hooks/useConfirmDialog';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export const TerminalMapping = () => {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();
  const { translate } = useTranslation();
  const transFormName = 'TerminalMapping.List';

  const { open } = useConfirmDialog({
    title: translate!('Delete', ''),
    bodyHtml: translate!('Are you sure?', ''),
    cancelButtonTitle: translate!('Cancel', ''),
    confirmButtonTitle: translate!('Confirm', ''),
  });

  useEffect(() => {
    setValue({
      pageName: 'Terminal mapping',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const {
    data,
    error,
    mutate: mutateTerminalMapings,
  } = useSWR(`${API_URL.TERMINAL_MAPPING_LIST}`, fetcher, swrConfig);

  const handleEditButton = (e): void => {
    history.push(`/admin-terminal-mapping/edit/${e.row.data.id}`);
  };

  const handleDeleteButton = async (e) => {
    open().then(async (c) => {
      if (c === confirmDialogActions.CONFIRM) {
        await deleteApi({
          url: `${API_URL.TERMINAL_MAPPING_DELETE}?id=${e.data.id}`,
          id: e.data.id,
          callAfterSuccess: () => mutateTerminalMapings(),
        });
      } else if (c === confirmDialogActions.CANCEL) {
        return false;
      }
    });
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <TerminalMappingsDataGrid
        data={data}
        handleEdit={handleEditButton}
        handleDelete={handleDeleteButton}
      />
    </PageContentWrapper>
  );
};
